import { render, staticRenderFns } from "./Composantes.vue?vue&type=template&id=084be0b9"
import script from "./Composantes.vue?vue&type=script&lang=js"
export * from "./Composantes.vue?vue&type=script&lang=js"
import style0 from "./Composantes.vue?vue&type=style&index=0&id=084be0b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports